<template>
    <div class="menu">
        <div class="inner" @click="onFold">
            <span class="title" :style="textStyle">{{ $getConfigText(menu.name) }}</span>
            <div v-if="menu.children && menu.children.length" :class="['fold-btn', {active: activeMenuId === menu.menuId}]">
                <i class="iconfont icon-mobile_navigation_up" v-show="activeMenuId === menu.menuId"></i>
                <i class="iconfont icon-mobile_navigation_down" v-show="activeMenuId !== menu.menuId"></i>
            </div>
        </div>
        <div class="hr"></div>
        <div class="sub" v-show="activeMenuId === menu.menuId">
            <div class="container" v-for="child in menu.children" :key="child.menuId">
                <div class="inner" @click="jumpTo(child)">
                    <span class="sub-title">{{ $getConfigText(child.name) }}</span>
                </div>
                <div class="hr"></div>
            </div>
        </div>
    </div>
</template>

<style lang='scss' scoped>
.menu{
    display: flex;
    flex-direction: column;
    .inner{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: 1.6rem;
        .title{
            font-size: 0.43rem;
            line-height: 0.59rem;
            font-weight: bold;
            color: #1F1F1F;
        }
        .fold-btn > .iconfont{
            color: #999;
            font-size: .18rem;
        }
        .fold-btn.active > .iconfont{
            color: var(--activeColor);
        }
    }
    .hr{
        width: 100%;
        border-bottom: 1px solid #EBEBEB;
    }
    .sub{
        padding-left: .4rem;
        .sub-title{
            font-size: 0.37rem;
            font-weight: 400;
        }
    }
}
</style>

<script>
export default {
    name: 'NavItem',
    props: {
        menu: Object
    },
    data(){
        return {
            activeMenuId: null
        }
    },
    computed: {
        textStyle(){
            return this.menu.active ? 'color: var(--activeColor);' : ''
        }
    },
    methods: {
        onFold(){
            if(!this.menu.children || !this.menu.children.length){
                this.jumpTo(this.menu)
                return
            }
            if(this.activeMenuId === this.menu.menuId){
                this.activeMenuId = null
            }else{
                this.activeMenuId = this.menu.menuId
            }
        },
        jumpTo(route){
            if(route.isFrame){
                window.open(route.path)
            }else{
                window.location.href = route.path
            }
            this.$emit('active', this.menu)
            this.$emit('close')
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/layout/m-header/nav-list/nav-item.vue